<template>
  <div>
    <ul
      class="toggle-switch"
      :class="{'square' : defaultOptions.layout.squareCorners}"
      :style="toggleSwitchStyle"
    >
      <li
        v-for="(label, index) in defaultOptions.items.labels"
        :key="index"
        :style="itemStyle"
      >
        <input
          :id="label.name + group"
          :disabled="defaultOptions.items.disabled || disabled"
          :value="selectedItem[label.name]"
          :name="name"
          type="checkbox"
          @click="toggle(label.name)"
        >
        <label
          :style="(selectedItem[label.name]) ? labelStyleSelected(label.color, label.backgroundColor) : labelStyle "
          :class="{ active: !defaultOptions.items.disabled || disabled}"
          class="selected"
          :for="label.name + group"
          type="checkbox"
          :title="label.title"
          v-html="label.ico"
        >
          {{ label.name }}
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
const s = x => x + 's'
const px = v => v + 'px'

export default {
  props: {
    options: {
      type: Object,
      required: false
    },
    value: {
      type: Object,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    group: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      selected: false,
      selectedItem: {},
      defaultOptions: Object
    }
  },
  computed: {
    toggleSwitchStyle () {
      return {
        width: px(this.defaultOptions.size.width),
        height: px(this.defaultOptions.size.height)
      }
    },
    itemStyle () {
      return {
        width: px(this.defaultOptions.size.width),
        height: px(this.defaultOptions.size.height),
        fontFamily: this.defaultOptions.layout.fontFamily,
        fontSize: px(this.defaultOptions.size.fontSize),
        textAlign: 'center'
      }
    },
    labelStyle () {
      return {
        padding: px(this.defaultOptions.size.padding),
        borderColor: this.defaultOptions.layout.noBorder ? 'transparent' : this.defaultOptions.layout.borderColor,
        backgroundColor: this.defaultOptions.layout.backgroundColor,
        color: this.defaultOptions.layout.color,
        fontWeight: this.defaultOptions.layout.fontWeight,
        transition: s(this.defaultOptions.items.delay)
      }
    }
  },
  watch: {
    value (val) {
      this.selectedItem = val
    },
    options (val) {
      if (val !== null && val !== undefined) {
        this.mergeDefaultOptionsWithProp(val)
      }
    }
  },
  created () {
    this.defaultOptions = {
      layout: {
        color: 'black',
        backgroundColor: 'gainsboro',
        selectedColor: 'white',
        selectedBackgroundColor: '#FFC0A4',
        borderColor: 'lightgray',
        fontFamily: 'Roboto',
        fontWeight: 'normal',
        fontWeightSelected: 'normal',
        squareCorners: false,
        noBorder: false
      },
      size: {
        fontSize: 18,
        height: 30,
        padding: 5,
        width: 100
      },
      items: {
        delay: 0.4,
        preSelected: 'unknown',
        disabled: false,
        labels: [
          {ico: '<span class="mdi mdi-access-point-network"></span>', name: 'online', title: this.translate('filter.status.online'), color: '#41B883', backgroundColor: '#ABF3CB'},
          // {ico: '<span class="mdi mdi-chart-box"></span>', name: 'crit_traffic', title: this.translate('filter.status.crit_traffic'), color: 'orange', backgroundColor: '#ffe7a4'},
          // {ico: '<span class="mdi mdi-lock"></span>', name: 'blocked', title: this.translate('filter.status.blocked'), color: 'red', backgroundColor: '#FFC0A4'},
        ]
      }
    }
  },
  mounted () {
    if (this.options !== null && this.options !== undefined) {
      this.mergeDefaultOptionsWithProp(this.options)
    }
    this.selectedItem = this.value
  },
  methods: {
    toggle (name) {
      this.$emit('toggle', name, !this.selectedItem[name])
    },
    labelStyleSelected (color, backgroundColor) {
      return {
        padding: px(this.defaultOptions.size.padding),
        borderColor: this.defaultOptions.layout.noBorder ? 'transparent' : this.defaultOptions.layout.borderColor,
        fontWeight: this.defaultOptions.layout.fontWeightSelected,
        backgroundColor: backgroundColor !== undefined ? backgroundColor : this.defaultOptions.layout.selectedBackgroundColor,
        color: color !== undefined ? color : this.defaultOptions.layout.selectedColor,
        transition: s(this.defaultOptions.items.delay)
      }
    },
    mergeDefaultOptionsWithProp (options) {
      var result = this.defaultOptions
      for (var option in options) {
        if (options[option] !== null && typeof (options[option]) === 'object') {
          for (var subOption in options[option]) {
            if (options[option][subOption] !== undefined && options[option][subOption] !== null) {
              result[option][subOption] = options[option][subOption]
            }
          }
        } else {
          result[option] = options[option]
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
ul.toggle-switch {
  list-style: none;
  vertical-align: middle;
}
.toggle-switch label {
  margin: 0;
  line-height: 1em;
}
.toggle-switch label > * {
  vertical-align: middle;
}
.toggle-switch {
  padding: 0;
  margin: 0;
  display: inline-flex;
}
.square li:first-child label {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.square li:last-child label {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.toggle-switch li {
  position:relative;
  margin: 0;
  line-height: 1.15em;
  span.online{
    color: #41B883;
  }
}
.toggle-switch li:first-child label {
  border: 1px solid;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.toggle-switch li:last-child label {
  border-right: 1px solid;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
.toggle-switch label, .toggle-switch input {
  display:block;
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
}
.toggle-switch input[type="checkbox"] {
  opacity:0.01;
  z-index:100;
}
.toggle-switch li:not(:first-child):not(:last-child) label {
  border-right: 1px solid;
  border-top: 1px solid;
  border-bottom: 1px solid;
}
.active {
  cursor: pointer;
}
</style>
